export default "__VITE_ASSET__DMYMejQf__"